<link rel="stylesheet" href="resource/css/common.css" />
<link rel="stylesheet" href="resource/css/style.css" />

<header>
    <img src="resource/img/logo.png" alt="logo" class="logo-hd">
</header>